"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeStore = exports.store = exports.createStoreWithInitialState = exports.rootReducer = void 0;

var _redux = require("redux");

var _constants = require("../constants");

var _persist = _interopRequireDefault(require("./middleware/persist"));

var _thunk = _interopRequireDefault(require("./middleware/thunk"));

var _app = _interopRequireDefault(require("./reducers/app"));

var _conversation = _interopRequireDefault(require("./reducers/conversation"));

var _survey = _interopRequireDefault(require("./reducers/survey"));

var _helpStorage = require("@ua/help-storage");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var rootReducer = (0, _redux.combineReducers)({
  app: _app["default"],
  conversation: _conversation["default"],
  survey: _survey["default"]
});
exports.rootReducer = rootReducer;
var expirationTimeMillis = 1000 * 60 * 30; // 30 minute store expiry

var composeEnhancers = global.window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || _redux.compose;

var createStoreWithInitialState = function createStoreWithInitialState(initialState) {
  return (0, _redux.createStore)(rootReducer, initialState, composeEnhancers((0, _redux.applyMiddleware)(_thunk["default"], _persist["default"])));
};

exports.createStoreWithInitialState = createStoreWithInitialState;
var store = createStoreWithInitialState({});
exports.store = store;

var initializeStore = function initializeStore(_ref) {
  var env, stateFetchedString, initialState, expires, difference;
  return regeneratorRuntime.async(function initializeStore$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          env = _ref.env;
          _context.next = 3;
          return regeneratorRuntime.awrap((0, _helpStorage.initialize)({
            env: env
          }));

        case 3:
          _context.next = 5;
          return regeneratorRuntime.awrap((0, _helpStorage.getItem)(_constants.LOCALSTORAGE_KEY_STORE));

        case 5:
          stateFetchedString = _context.sent;
          initialState = {};

          try {
            initialState = JSON.parse(stateFetchedString);
          } catch (error) {
            console.error('Could not parse saved state...'); // eslint-disable-line no-console
          } // Reset initial state if past expiry


          _context.t0 = Number;
          _context.next = 11;
          return regeneratorRuntime.awrap((0, _helpStorage.getItem)(_constants.LOCALSTORAGE_KEY_STORE_EXPIRES));

        case 11:
          _context.t1 = _context.sent;
          expires = (0, _context.t0)(_context.t1);
          difference = Date.now() - expires;

          if (difference > expirationTimeMillis) {
            initialState = {};
          }

          exports.store = store = createStoreWithInitialState(initialState);

        case 16:
        case "end":
          return _context.stop();
      }
    }
  });
};

exports.initializeStore = initializeStore;